import React from 'react';
import flatten from 'lodash.flatten';
import styled from 'styled-components/macro';
import { max, min } from 'd3-array';
import first from 'lodash.first';
import last from 'lodash.last';

const Line = styled('line')`
  stroke-width: 2;
  stroke-dasharray: 4 4;
  stroke: ${({ color }): any => color};
`;

interface INotNullProps {
  color: string;
  entities: any;
  isFirst: boolean;
  nullSegment: number[];
  xScale: any;
  yKey: string;
  yScale: any;
}

const MissingValues: React.FC<INotNullProps> = (props) => {
  const { color, entities, isFirst, nullSegment, xScale, yKey, yScale } = props;
  const idx = Number(
    isFirst ? max(flatten(nullSegment)) : min(flatten(nullSegment))
  );
  const from = isFirst ? 0 : idx - 1;
  const to = isFirst ? Number(max(flatten(nullSegment))) + 2 : entities.length;
  const interpolatedTrend =
    entities && entities.length > 0 && isFinite(idx)
      ? entities.slice(from, to).map((d: any) => ({
          ...d,
          [yKey]: entities[isFirst ? idx + 1 : idx - 1][yKey],
        }))
      : [];

  return (
    <>
      {interpolatedTrend.length > 0 ? (
        <Line
          x1={xScale((first(interpolatedTrend) as any).periodKey)}
          x2={xScale((last(interpolatedTrend) as any).periodKey)}
          y1={yScale((first(interpolatedTrend) as any)[yKey])}
          y2={yScale((last(interpolatedTrend) as any)[yKey])}
          stroke={color}
        />
      ) : null}
    </>
  );
};

export default MissingValues;
